import React from "react";

function YEBNeeds() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>
              Why Choose Xeer Technology for Your Enterprise Blockchain Needs ?
            </h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Our expertise across industries ensures a deep understanding
                  of your business needs, providing innovative, compliant, and
                  scalable blockchain solutions that enhance efficiency and
                  trust within your organization.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default YEBNeeds;
